import PropTypes from "prop-types";
import React, { useMemo } from "react";

const Pictogram = (props) => {
  const { folder, pictogram, withBackground = false, backgroundPictogram = "ovoid" } = props;

  const withExtension = useMemo(() => (pictogram.includes(".svg") ? "" : ".svg"), [pictogram]);
  const folderToLowerCase = folder.toLowerCase();

  if (withBackground) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="fr-responsive-img fr-artwork"
        aria-hidden="true"
        width="160"
        height="200"
        viewBox="0 0 160 200"
      >
        <use
          className="fr-artwork-motif"
          href={`/@gouvfr/dsfr/dist/artwork/background/${backgroundPictogram}.svg#artwork-motif`}
        />
        <use
          className="fr-artwork-background"
          href={`/@gouvfr/dsfr/dist/artwork/background/${backgroundPictogram}.svg#artwork-background`}
        />
        <g transform="translate(40, 60)">
          <use
            className="fr-artwork-decorative"
            href={`/@gouvfr/dsfr/dist/artwork/pictograms/${folderToLowerCase}/${pictogram}${withExtension}#artwork-decorative`}
          />
          <use
            className="fr-artwork-minor"
            href={`/@gouvfr/dsfr/dist/artwork/pictograms/${folderToLowerCase}/${pictogram}${withExtension}#artwork-minor`}
          />
          <use
            className="fr-artwork-major"
            href={`/@gouvfr/dsfr/dist/artwork/pictograms/${folderToLowerCase}/${pictogram}${withExtension}#artwork-major`}
          />
        </g>
      </svg>
    );
  }

  return (
    <svg className="fr-artwork" aria-hidden="true" viewBox="0 0 80 80" width="100%" height="100%">
      <use
        className="fr-artwork-decorative"
        href={`/@gouvfr/dsfr/dist/artwork/pictograms/${folderToLowerCase}/${pictogram}${withExtension}#artwork-decorative`}
      />
      <use
        className="fr-artwork-minor"
        href={`/@gouvfr/dsfr/dist/artwork/pictograms/${folderToLowerCase}/${pictogram}${withExtension}#artwork-minor`}
      />
      <use
        className="fr-artwork-major"
        href={`/@gouvfr/dsfr/dist/artwork/pictograms/${folderToLowerCase}/${pictogram}${withExtension}#artwork-major`}
      />
    </svg>
  );
};

Pictogram.propTypes = {
  folder: PropTypes.string.isRequired,
  pictogram: PropTypes.string.isRequired,
  withBackground: PropTypes.bool,
  backgroundPictogram: PropTypes.string,
};

export default Pictogram;
